export enum EnMinWidthScreen {
  XXL = '(min-width: 1440px)',
  LG = '(min-width: 1024px)',
  MD = '(min-width: 768px)',
  SM = '(min-width: 576px)',
  SM_XS = '(min-width: 468.9px)',
  XS = '(min-width: 375px)',
}
export enum EnMaxWidthScreen {
  XXL = '(max-width: 1439.8px)',
  LG = '(max-width: 1023.98px)',
  MD = '(max-width: 767.98px)',
  SM = '(max-width: 575.98px)',
  SM_XS = '(max-width: 468.9px)',
  XS = '(max-width: 374.98px)',
}
